/** A user's theme *choice* (what they picked) vs the *resolved* concrete mode. */
export type ThemeChoice = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

/**
 * Pure precedence resolver: a `system` choice resolves against the OS
 * preference, an explicit choice wins outright. Exported for unit testing and
 * reused by both the client store and the (cookie-fed) server stamp.
 */
export function resolveTheme(choice: ThemeChoice, systemPrefersDark: boolean): ResolvedTheme {
  if (choice === "system") {
    return systemPrefersDark ? "dark" : "light";
  }
  return choice;
}

/** Narrows an untrusted string to a valid {@link ThemeChoice}, or null. */
export function parseThemeChoice(value: string | null | undefined): ThemeChoice | null {
  return value === "light" || value === "dark" || value === "system" ? value : null;
}
